/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconBofang: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z m0 955.904c-244.736 0-443.904-199.168-443.904-443.904 0-244.736 199.168-443.904 443.904-443.904s443.904 199.168 443.904 443.904c0 244.736-199.168 443.904-443.904 443.904z m160.768-501.76L493.056 347.648c-20.992-12.288-46.08-12.8-67.584-0.512-20.992 12.288-33.792 33.792-33.792 58.368v213.504c0 24.576 12.8 46.08 33.792 58.368 10.24 6.144 22.016 8.704 33.28 8.704 11.776 0 23.552-3.072 34.304-9.216l180.224-106.496c20.48-12.288 32.768-33.792 32.768-57.856 0-24.576-12.288-46.08-33.28-58.368z m-212.992 162.304l-2.048-210.432 180.224 104.448-178.176 105.984z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </svg>
  );
};

IconBofang.defaultProps = {
  size: 18,
};

export default IconBofang;
